import React from 'react';
import { Text } from '@oneaudi/unified-web-components';
import { scriptRegex } from '../../utils/string-utils';

const AudiHeaderTeaserTechLabel: React.FC<{
  techLabelValue: string;
  useFootnoteReferenceServiceTextParserHook: (htmlString: string) => string;
}> = ({ useFootnoteReferenceServiceTextParserHook, techLabelValue }) => {
  const dangerousHTML = useFootnoteReferenceServiceTextParserHook(
    techLabelValue.replace(scriptRegex, ' illegal script '),
  );
  return (
    <Text
      tag="p"
      variant={{
        order: '2',
        style: 'normal',
        type: 'copy',
      }}
    >
      <span
        dangerouslySetInnerHTML={{
          __html: dangerousHTML,
        }}
      />
    </Text>
  );
};

export default AudiHeaderTeaserTechLabel;
